"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _FormViewMixin = _interopRequireDefault(require("./FormViewMixin"));

var _ContactOrganizer = _interopRequireDefault(require("../models/ContactOrganizer"));

var _PopupView = _interopRequireDefault(require("./PopupView"));

var _contact_organizer = _interopRequireDefault(require("hbars!../templates/contact_organizer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactOrganizerView = _PopupView.default.extend({
  events: {
    'click .cancel-action': 'cancelClicked',
    'click .send-action': 'sendClicked'
  },
  initialize: function initialize(options) {
    options = options || {};
    this.model = new _ContactOrganizer.default();

    _PopupView.default.prototype.initialize.call(this);
  },
  remove: function remove() {
    this.removeValidation();
    return _backbone.default.View.prototype.remove.call(this);
  },
  cancelClicked: function cancelClicked() {
    this.hide();
  },
  sendClicked: function sendClicked() {
    var thisView = this;
    var valid = this.model.isValid(true);

    if (!valid) {
      return;
    }

    (0, _jquery.default)('.send-action').attr('disabled', true);

    var success = function success() {
      thisView.model.clear();
      thisView.hide();
    };

    var error = function error() {
      (0, _jquery.default)('.send-action').removeAttr('disabled');
    };

    this.model.save(null, {
      success: success,
      error: error
    });
  },
  render: function render() {
    var html = (0, _contact_organizer.default)(this.model.toJSON());
    this.$el.html(html);
    this.initValidation({
      attrs: ['from', 'sender', 'body', 'company', 'phone'],
      trackModels: []
    });
    this.renderForm();
    return this;
  }
});

_underscore.default.extend(ContactOrganizerView.prototype, _FormViewMixin.default);

var _default = ContactOrganizerView;
exports.default = _default;